import { createEndpoint } from '@/shared/models/api';
import { CalculationInformation } from '@/app/api/morgan-thermal/calculation';

export const getCalculation = createEndpoint<CalculationInformation>(({fetch}) => (id: CalculationInformation['id']) => fetch(`/Calculation/Get/${id}`));